import { useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { playSound, Sound } from '~/assets/sounds';
import { TextLabel } from '../TextLabel';
import {
	StyledAcceptButton,
	StyledButtonsContainer,
	StyledContainer,
	StyledImg,
	StyledItemLeftContainer,
	StyledItemPlayerInfo,
	StyledList,
	StyledListContainer,
	StyledListItem,
	StyledRejectButton,
	StyledRequestsButton,
} from './AppMessageFriendsRequests.styled';

const AppMessageFriendsRequests = () => {
	const [listVisible, setListVisible] = useState(false);
	const listRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!listVisible) {
			return;
		}

		function handleClickOutside(event: Event) {
			if (listRef.current && !listRef.current.contains(event.target as Node)) {
				setListVisible(false);
			}
		}

		setTimeout(() => {
			document.addEventListener('click', handleClickOutside);
		}, 300);

		return () => {
			document.removeEventListener('click', handleClickOutside);
		};
	}, [listRef, listVisible]);

	return (
		<StyledContainer>
			<StyledRequestsButton
				onClick={() => {
					setListVisible(true);
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			>
				<div className={'dot'} />
				<div className={'icon'} />
			</StyledRequestsButton>
			<CSSTransition
				timeout={300}
				in={listVisible}
				classNames={'list'}
				unmountOnExit
			>
				<StyledListContainer ref={listRef}>
					<TextLabel
						style={{ fontSize: 14, fontWeight: 500, color: '#000000' }}
					>
						Заявки
					</TextLabel>
					<StyledList>
						<div className={'line'} />
						<StyledListItem>
							<StyledItemLeftContainer>
								<StyledImg />
								<StyledItemPlayerInfo>
									<TextLabel>stdian</TextLabel>
									<TextLabel>Отправлено 2 ч. назад</TextLabel>
								</StyledItemPlayerInfo>
							</StyledItemLeftContainer>
							<StyledButtonsContainer>
								<StyledAcceptButton
									onClick={() => {
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								/>
								<StyledRejectButton
									onClick={() => {
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								/>
							</StyledButtonsContainer>
						</StyledListItem>
						<div className={'line'} />
						<StyledListItem>
							<StyledItemLeftContainer>
								<StyledImg />
								<StyledItemPlayerInfo>
									<TextLabel>stdian</TextLabel>
									<TextLabel>Отправлено 2 ч. назад</TextLabel>
								</StyledItemPlayerInfo>
							</StyledItemLeftContainer>
							<StyledButtonsContainer>
								<StyledAcceptButton
									onClick={() => {
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								/>
								<StyledRejectButton
									onClick={() => {
										playSound(Sound.ClickButton);
									}}
									onMouseEnter={() => playSound(Sound.LinkCursor)}
								/>
							</StyledButtonsContainer>
						</StyledListItem>
					</StyledList>
				</StyledListContainer>
			</CSSTransition>
		</StyledContainer>
	);
};

export { AppMessageFriendsRequests };
